const DEFAULT_MINIMAL_CHARS_NUMBER = 3;

type UseValidatedSearchIdOptions = {
  minimalCharsNumber: number;
};

export const useValidatedSearchId = (search: string, options?: UseValidatedSearchIdOptions) => {
  const minimalCharsNumber = options?.minimalCharsNumber ?? DEFAULT_MINIMAL_CHARS_NUMBER;
  const validatedSearch = search.length >= minimalCharsNumber ? search : '';
  return { search: validatedSearch };
};
